type EventClosedState = {
  variants?: Array<{ variant_id: number }>;
  closed?: number[] | null;
  boat_closed?: boolean;
};

export function isEventFullyClosed(event?: EventClosedState): boolean {
  if (event?.boat_closed) {
    return true;
  }

  const variants = event?.variants ?? [];
  const closedVariantIds = event?.closed ?? [];

  return (
    variants.length > 0 &&
    variants.every(variant => closedVariantIds.includes(variant.variant_id))
  );
}
